import { Checkbox } from 'antd'
import React from 'react'
import { useGetEventUserQuery } from '../../../api/eventUser.api'
import { useAddCategoryMutation, useGetCategoriesQuery, useRemoveCategoryMutation } from '../../../api/v2/categories'
import { useMyContext } from '../../../context/context'
import useSettingsV2 from '../../../hooks/useSettingsV2'
import { useSteps } from '../Steps'

export default function Categories() {
  const { myContext } = useMyContext()
  const { settings } = useSettingsV2()
  const { userId, NextButton, nextStep } = useSteps()

  const { data: user } = useGetEventUserQuery({ ...myContext, userId })

  const companyId = user?.UserEvent?.Employee?.Company?.id

  const { data } = useGetCategoriesQuery({ ...myContext, companyId })
  const [add] = useAddCategoryMutation()
  const [remove] = useRemoveCategoryMutation()

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      {settings?.FO_MEETING_CATEGORIES_HTML && <div dangerouslySetInnerHTML={{ __html: settings.FO_MEETING_CATEGORIES_HTML }} />}

      {data?.categoriesOptions.map(c => (
        <div>
          <div
            style={{
              backgroundColor: settings?.FO_MEETING_CONFERENCES_V2_COLOR,
              textAlign: 'center',
              color: 'white',
              fontWeight: 700,
              borderRadius: 50,
              padding: '8px 16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {c.label}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, padding: 8 }}>
            {c.options.map(o => (
              <Checkbox
                checked={!!data?.categoriesCompany?.find(f => f === o.value)}
                style={{ fontWeight: 600, marginLeft: 0, fontSize: 26 }}
                onClick={e =>
                  e.target.checked ? add({ categoryId: o.value, companyId }) : remove({ categoryId: o.value, companyId })
                }
              >
                {o.label}
              </Checkbox>
            ))}
          </div>
        </div>
      ))}
      <NextButton onClick={() => nextStep()} />
    </div>
  )
}
